import { FC, useMemo } from 'react';

import { DailyAppointment } from '@/models/appointment/Appointment.ts';
import { CalendarInfo } from '@/models/appointment/EnrichedPractitionerData.ts';

import { dayjs } from '@/utils/dayjsSetup.ts';

import Paragraph from '../text/Paragraph.tsx';

interface Props {
    appointment: DailyAppointment;
    color: string;
    allCalendars?: CalendarInfo[];
}

const AllDayAppointment: FC<Props> = ({ appointment, color, allCalendars }) => {
    const calendar_id = appointment.links?.calendar_id;

    const practitioner_name = useMemo(() => {
        if (!calendar_id || !allCalendars || allCalendars.length === 0) return undefined;

        const calendar = allCalendars.find((cal) => cal.id === calendar_id);
        return calendar?.name;
    }, [calendar_id, allCalendars]);

    return (
        <div
            className="flex items-center rounded border border-l-8 border-slate-200 bg-striped-gray px-1 py-0.5 text-xs"
            style={{ borderLeftColor: color }}
        >
            <Paragraph className="truncate">
                {appointment.description || dayjs(appointment.start).format('DD HH:mm') || 'Untitled'}
                {practitioner_name && <span className="ml-1 text-slate-500">({practitioner_name})</span>}
            </Paragraph>
        </div>
    );
};

export default AllDayAppointment;
